export default __webpack_public_path__ + "static/media/BWP ZOO WEB ICON museum CY.350225cf.png";